//SendUserEmails

import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import "./SendUserEmails.css";
import axios from 'axios';

class SendUserEmails extends Component {
  constructor(props) {
    super(props);
    this.state = {
        redirect : false,
        wasSentSuccessfully : false,
        subscribedUsers : []
    };

    this.subscribeUser = this.subscribeUser.bind(this); 
    this.userIsSubscribed = this.userIsSubscribed.bind(this);
    this.subscribeAll = this.subscribeAll.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.sendEmails = this.sendEmails.bind(this);
    this.submitForm = this.submitForm.bind(this);
  }
  componentDidMount(){
   
  }
  subscribeUser(user){
    console.log('subscribeUser(user)',user);
    if(this.state.subscribedUsers.some((_user)=>_user===user.username)){
        console.log('user alredy there, removing user');
        let withoutUser=[...this.state.subscribedUsers];
        withoutUser.splice(withoutUser.indexOf(user.username),1);
        this.setState({
            subscribedUsers : [...withoutUser]
        });
    } else{
        this.setState({
            subscribedUsers : [...this.state.subscribedUsers,user.username]
        });
    }
  }
  userIsSubscribed(userEmail){
      console.log('!!!!!userIsSubscribed()');
      return this.state.subscribedUsers.includes(userEmail);
  }
  subscribeAll(){
    console.log('subscribeAll()');
    if(this.state.subscribedUsers.length===this.props.users.length){
        this.setState({
            subscribedUsers : []
        });
    }else{
        let allUsers = this.props.users.map((user)=>user.username);
        this.setState({
            subscribedUsers : [...allUsers]
        });
    }
  }  
  handleClose(){
    this.setState({ redirect: true });
  }
  sendEmails(){
    const sendTo = this.state.subscribedUsers.join(),
    subject = this.emailSubjectField.value,
    message = this.emailBodyField.value; 
    console.log('sendEmails()',sendTo,subject,message); 
    console.log('sendEmails()',this.state.subscribedUsers.length,subject.length,message.length); 
      if(this.state.subscribedUsers.length>=1 && subject.length>2 && message.length>1){
        console.log('sendEmails to server()'); 
        //const URL=`http://www.retinafunk.com/boda/send-emails-on-golf/?to=${sendTo}&subject=${subject}&message=${message}`;
        const URL=`https://www.on-golf.de/calendar/sendEmails.php/?to=${sendTo}&subject=${subject}&message=${message}`;
       axios.get(URL).then((response)=>{
         console.log('server response ',response);
         if (response.data==='Email sent'){
            this.setState({
                wasSentSuccessfully : true
            });
         }
       }).catch(err=>console.error(err));
      }
  }
  submitForm(event){
        event.preventDefault();
  }
  render(){
      
      return this.state.redirect ? (
        <Redirect to="/" />
      ) : (
        <div className="modal is-active">
            <div onClick={this.handleClose} className="modal-background"></div>
            <div className="modal-content">
                <div className="box user-list-container ">
                    <h2>E-Mails an Mitglieder senden!</h2>
                    {this.state.wasSentSuccessfully &&  (<div>Alle Emails wurden erfolgreich gesendet!</div>) }
                    <table className="users-table">
                        <thead>
                            <tr><th></th>
                            <th>Name</th>
                            <th>E-mail</th>
                            <th><input onChange={this.subscribeAll} type="checkbox"/></th></tr>
                        </thead><tbody>{
                           
                            this.props.users.map((user,index)=>{
                                console.log('x',this.userIsSubscribed(user.username));
                                let selectedProps ={
                                    checked : this.userIsSubscribed(user.username)
                                };
                                return <tr key={index}><td>{index}</td><td>{user.displayName}</td><td>{user.username}</td><td><input {...selectedProps} onChange={()=>{this.subscribeUser(user)}}  type="checkbox"/></td></tr>
                            })
                        }</tbody></table>    
                        <form action="" className="form" onSubmit={this.submitForm}>
                        <div className="field">
                        <label htmlFor="">E-mail Betreff </label>
                                <p className="control">
                                <input className="input"  type="text" name="subject" ref={elem=>this.emailSubjectField=elem} id="" required></input>
                                </p>
                       
                    
                        </div>
                        <div className="field">
                        <label htmlFor=""> E-mail Text</label>
                        <p className="control">
                        <textarea className="textarea"  name="message" ref={elem=>this.emailBodyField=elem} id="" cols="30" rows="10" required></textarea>
                        </p>
                        </div>
                        <div><button className="button" onClick={this.sendEmails}>Jetzt Senden!</button></div>
                        </form>
                </div>
            </div>  
        </div>
    );
}
}

export default SendUserEmails;


// WEBPACK FOOTER //
// ./src/SendUserEmails.js